import React from 'react';
import { Row, Col, Card, Image } from 'antd';
import { useLocation } from 'react-router-dom';
import TruncatedText from '../../helpers/TruncatedText';

const CategoryFilesList = ({ files, handleSelectedProductId, setOpen, categoryId, likedItems, toggleLike }) => {

    const currentPage = useLocation().pathname

    return (
        <Row gutter={[16, 16]} justify="start" style={{ marginLeft: '0px', marginRight: '0px', width: '100%' }}>
            {files?.map((file , index) => {
                const isLiked = likedItems && (likedItems[file?.id] ?? file?.is_favoured_by_user);

                return (
                    <Col key={index} xs={12} sm={12} md={8} lg={6} style={{ display: 'flex', justifyContent: 'center', width: '100%',padding: '0 4px' }}>
                        <Card
                            style={{ width: '100%', height: '100%' }}
                            onClick={() => handleSelectedProductId(file.id, categoryId)}
                            hoverable
                            cover={
                                <Image
                                    span={24}
                                    preview={false}
                                    alt={file.name}
                                    src={file.image}
                                    className="card-image"
                                    onClick={() => setOpen(true)}
                                    style={{ objectFit: 'cover', width: '100%', height: '100%' }}
                                />
                            }
                            className="product-card"
                        >
                            <div className="item-label">
                                <div className="circle"></div>
                                <TruncatedText text={file.name}/>
                            </div>
                            {
                                currentPage !== '/download' &&
                                <span
                                    className={`heart-icon ${isLiked ? 'liked' : ''}`}
                                    onClick={() => toggleLike(file?.id, isLiked)}
                                />
                            }
                        </Card>
                    </Col>
                );
            })}
        </Row>
    )
}

export default CategoryFilesList
